export default "__VITE_ASSET__Dpz_lw1D__"